/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GoogleMapsLoaderService } from './app/pages/maps/gmaps/gmap.service';
if (environment.production) {
  enableProdMode();
}

GoogleMapsLoaderService.load().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}).catch((error) => {
  console.log('Error loading Google Maps API:', error);
});
